/**
 * Component for rendering fillSl2Form tool output. See fill-sl1-form-tool.tsx for why
 * this is intentionally a no-op — generated files are hoisted at the message level.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function FillSl2FormTool(_props: { part: unknown; messageUuid: string }) {
  return null;
}
